// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomePageCategorySkeleton-topCategorySkeletonContainer-JuUxI {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    padding: 90px 0;
}

.HomePageCategorySkeleton-topCategorySkeletonHeading-kczY9 {
    max-width: 359px;
    height: 50px;
    border-radius: var(--radius-5);
    margin: 0 auto 48px;
}

.HomePageCategorySkeleton-topCategorySkeletonList-q1xJ4 {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 42px;
}

.HomePageCategorySkeleton-topCategorySkeletonListItem-nO6Kx {
    border-radius: 0 var(--radius-3) 0 var(--radius-3);
    background-color: var(--skeleton-primary-bg);
}

.HomePageCategorySkeleton-topCategorySkeletonListImgContainer-rZHfg {
    height: 184px;
    width: 100%;
    max-width: 100%;
    padding: 12px;
}

.HomePageCategorySkeleton-topCategorySkeletonListImg-ZCJZW {
    width: 100%;
    height: 100%;
    background-color: var(--skeleton-secondary-bg);
    border-radius: 0 var(--radius-2) 0 var(--radius-2);
}

.HomePageCategorySkeleton-topCategorySkeletonListInfo-ONyg_ {
    padding: 6px 24px 24px 24px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.HomePageCategorySkeleton-topCategorySkeletonListTitle-z31Mw {
    max-width: 148px;
    height: 28px;
    background-color: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

.HomePageCategorySkeleton-topCategorySkeletonListDescBox-CXKDT {
    width: 100%;
    margin-top: 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 6px;
}

.HomePageCategorySkeleton-topCategorySkeletonListDesc-oEgqw {
    max-width: 100%;
    height: 18px;
    background-color: var(--skeleton-secondary-bg);
    border-radius: var(--radius-5);
}

@media (max-width: 1199px) and (min-width: 1024px) {
    .HomePageCategorySkeleton-topCategorySkeletonList-q1xJ4 {
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
    }

    .HomePageCategorySkeleton-topCategorySkeletonListItem-nO6Kx:nth-child(4) {
        display: none;
    }

}

@media (max-width: 1023px) and (min-width: 768px) {
    .HomePageCategorySkeleton-topCategorySkeletonList-q1xJ4 {
        grid-template-columns: repeat(3, 1fr);
        gap: 15px;
    }

    .HomePageCategorySkeleton-topCategorySkeletonListItem-nO6Kx:nth-child(4) {
        display: none;
    }
}

@media (max-width: 991px) and (min-width: 768px) {
    .HomePageCategorySkeleton-topCategorySkeletonContainer-JuUxI {
        padding: 60px 0;
    }

    .HomePageCategorySkeleton-topCategorySkeletonHeading-kczY9 {
        height: 44px;
        margin-bottom: 36px;
    }
}

@media (max-width: 767px) {
    .HomePageCategorySkeleton-topCategorySkeletonContainer-JuUxI {
        padding: 48px 0;
    }

    .HomePageCategorySkeleton-topCategorySkeletonHeading-kczY9 {
        height: 34px;
        margin-bottom: 30px;
    }
}

@media (max-width: 767px) and (min-width: 576px) {
    .HomePageCategorySkeleton-topCategorySkeletonList-q1xJ4 {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
    }

    .HomePageCategorySkeleton-topCategorySkeletonListItem-nO6Kx:nth-child(3),
    .HomePageCategorySkeleton-topCategorySkeletonListItem-nO6Kx:nth-child(4) {
        display: none;
    }
}

@media (max-width: 575px) {
    .HomePageCategorySkeleton-topCategorySkeletonList-q1xJ4 {
        grid-template-columns: 100%;
        gap: 10px;
    }

    .HomePageCategorySkeleton-topCategorySkeletonListItem-nO6Kx:nth-child(2),
    .HomePageCategorySkeleton-topCategorySkeletonListItem-nO6Kx:nth-child(3),
    .HomePageCategorySkeleton-topCategorySkeletonListItem-nO6Kx:nth-child(4) {
        display: none;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/Home/HomePageCategorySkeleton/HomePageCategorySkeleton.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,kDAAkD;IAClD,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,kDAAkD;AACtD;;AAEA;IACI,2BAA2B;IAC3B,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,mBAAmB;IACvB;AACJ;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,mBAAmB;IACvB;AACJ;;AAGA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;;QAEI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,2BAA2B;QAC3B,SAAS;IACb;;IAEA;;;QAGI,aAAa;IACjB;;AAEJ","sourcesContent":[".topCategorySkeletonContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 90px 0;\n}\n\n.topCategorySkeletonHeading {\n    max-width: 359px;\n    height: 50px;\n    border-radius: var(--radius-5);\n    margin: 0 auto 48px;\n}\n\n.topCategorySkeletonList {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 42px;\n}\n\n.topCategorySkeletonListItem {\n    border-radius: 0 var(--radius-3) 0 var(--radius-3);\n    background-color: var(--skeleton-primary-bg);\n}\n\n.topCategorySkeletonListImgContainer {\n    height: 184px;\n    width: 100%;\n    max-width: 100%;\n    padding: 12px;\n}\n\n.topCategorySkeletonListImg {\n    width: 100%;\n    height: 100%;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: 0 var(--radius-2) 0 var(--radius-2);\n}\n\n.topCategorySkeletonListInfo {\n    padding: 6px 24px 24px 24px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.topCategorySkeletonListTitle {\n    max-width: 148px;\n    height: 28px;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n.topCategorySkeletonListDescBox {\n    width: 100%;\n    margin-top: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.topCategorySkeletonListDesc {\n    max-width: 100%;\n    height: 18px;\n    background-color: var(--skeleton-secondary-bg);\n    border-radius: var(--radius-5);\n}\n\n@media (max-width: 1199px) and (min-width: 1024px) {\n    .topCategorySkeletonList {\n        grid-template-columns: repeat(3, 1fr);\n        gap: 20px;\n    }\n\n    .topCategorySkeletonListItem:nth-child(4) {\n        display: none;\n    }\n\n}\n\n@media (max-width: 1023px) and (min-width: 768px) {\n    .topCategorySkeletonList {\n        grid-template-columns: repeat(3, 1fr);\n        gap: 15px;\n    }\n\n    .topCategorySkeletonListItem:nth-child(4) {\n        display: none;\n    }\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n    .topCategorySkeletonContainer {\n        padding: 60px 0;\n    }\n\n    .topCategorySkeletonHeading {\n        height: 44px;\n        margin-bottom: 36px;\n    }\n}\n\n\n@media (max-width: 767px) {\n    .topCategorySkeletonContainer {\n        padding: 48px 0;\n    }\n\n    .topCategorySkeletonHeading {\n        height: 34px;\n        margin-bottom: 30px;\n    }\n}\n\n\n@media (max-width: 767px) and (min-width: 576px) {\n    .topCategorySkeletonList {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 10px;\n    }\n\n    .topCategorySkeletonListItem:nth-child(3),\n    .topCategorySkeletonListItem:nth-child(4) {\n        display: none;\n    }\n}\n\n@media (max-width: 575px) {\n    .topCategorySkeletonList {\n        grid-template-columns: 100%;\n        gap: 10px;\n    }\n\n    .topCategorySkeletonListItem:nth-child(2),\n    .topCategorySkeletonListItem:nth-child(3),\n    .topCategorySkeletonListItem:nth-child(4) {\n        display: none;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topCategorySkeletonContainer": `HomePageCategorySkeleton-topCategorySkeletonContainer-JuUxI`,
	"topCategorySkeletonHeading": `HomePageCategorySkeleton-topCategorySkeletonHeading-kczY9`,
	"topCategorySkeletonList": `HomePageCategorySkeleton-topCategorySkeletonList-q1xJ4`,
	"topCategorySkeletonListItem": `HomePageCategorySkeleton-topCategorySkeletonListItem-nO6Kx`,
	"topCategorySkeletonListImgContainer": `HomePageCategorySkeleton-topCategorySkeletonListImgContainer-rZHfg`,
	"topCategorySkeletonListImg": `HomePageCategorySkeleton-topCategorySkeletonListImg-ZCJZW`,
	"topCategorySkeletonListInfo": `HomePageCategorySkeleton-topCategorySkeletonListInfo-ONyg_`,
	"topCategorySkeletonListTitle": `HomePageCategorySkeleton-topCategorySkeletonListTitle-z31Mw`,
	"topCategorySkeletonListDescBox": `HomePageCategorySkeleton-topCategorySkeletonListDescBox-CXKDT`,
	"topCategorySkeletonListDesc": `HomePageCategorySkeleton-topCategorySkeletonListDesc-oEgqw`
};
module.exports = ___CSS_LOADER_EXPORT___;
